module.exports = __webpack_public_path__ + "static/media/ic_close_menu.1a08ea9e.svg";